module.exports = __webpack_public_path__ + "static/media/banner-delivery.b59ed461.png";